import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "@zenith/app/store";
import { CartItem } from "@zenith/features/Payments/interfaces";

export interface CartState {
  cart: CartItem[];
}

const initialState: CartState = {
  cart: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      state.cart.push(action.payload);
    },
    emptyCart: (state) => {
      state.cart = [];
    },
    updateCart: (state, action) => {
      const { index, updatedItem } = action.payload;
      state.cart[index] = updatedItem;
    },
    updateCartItemQuantity: (state, action) => {
      const { index, quantity } = action.payload;
      state.cart[index].quantity = quantity;
    },
    deleteCartItem: (state, action) => {
      state.cart = state.cart.filter((item) => item.id !== action.payload);
    },
  },
});

export const {
  updateCartItemQuantity,
  addToCart,
  emptyCart,
  updateCart,
  deleteCartItem,
} = cartSlice.actions;

export const selectCart = (state: RootState) => state.cart.cart;

export default cartSlice.reducer;
